import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../layout"
import styles from "./styles"

const BundledPaymentsLayout = ({
  location,
  title,
  description,
  footerNote,
  pageId,
  children,
}) => (
  <Layout
    location={location}
    title={title}
    description={description}
    footerNote={footerNote}
  >
    <Helmet>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
      />
      <style type="text/css">{styles}</style>
    </Helmet>
    <div className="bp-page">
      <div className="page on" id={pageId}>
        {children}
      </div>
    </div>
  </Layout>
)

export default BundledPaymentsLayout
